<div class="wyswig" *ngIf="content" [innerHTML]="content | wysiwyg"></div>
